/** Base URL for the Express API (geo directory, applicants, masters, inventory). */
export function getApiBaseUrl(): string {
  if (typeof window !== "undefined") {
    const { protocol, hostname, port } = window.location;
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
    if (isLocalhost) {
      return `${protocol}//${hostname}:4000`;
    }
    // Dev UI (Parcel) and API run on different ports; support LAN/IP access too.
    if (port === "3000" || port === "3001" || port === "5173" || port === "1234") {
      return `${protocol}//${hostname}:4000`;
    }
    return `${protocol}//${hostname}${port ? `:${port}` : ""}`;
  }
  return "http://localhost:4000";
}
